import { render, staticRenderFns } from "./fullResults.vue?vue&type=template&id=5035d68a&scoped=true&"
import script from "./fullResults.vue?vue&type=script&lang=js&"
export * from "./fullResults.vue?vue&type=script&lang=js&"
import style1 from "./fullResults.vue?vue&type=style&index=1&id=5035d68a&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5035d68a",
  null
  
)

export default component.exports